import { Modal } from "antd";
import { ContainerItems, Icon, Items } from "../styles";

export default function ModalInfo({
  isModalOpen,
  handleFechar,
  arquivosSelecionado,
}: any) {
  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title={`Arquivo ${arquivosSelecionado?.nome}`}
      footer={null}
    >
      <ContainerItems>
        <Items>
          <strong>Tamanho:</strong>
          <Icon>{arquivosSelecionado?.tamanho || "—"}</Icon>
        </Items>
        <Items>
          <strong>Data Inclusão:</strong>
          <Icon>{arquivosSelecionado?.data_inclusao || "—"}</Icon>
        </Items>
      </ContainerItems>
    </Modal>
  );
}
